export const s = {
  avatarBase:
    "flex h-9 w-9 cursor-pointer items-center justify-center overflow-hidden rounded-full text-sm font-semibold",
  /** When showing a real image — keep the inside white so transparent PNGs
   *  don't bleed onto the brand color underneath, and add a subtle ring. */
  avatarImage: "bg-white ring-1 ring-gray-200",
  /** When falling back to initials — brand chip, white glyph. */
  avatarInitials: "bg-brand text-white",
  avatarImg: "h-full w-full object-cover",
};
